// extracted by mini-css-extract-plugin
export default {"loader":"climbing_stairs_loader__w1da8","loading-bounce":"climbing_stairs_loading-bounce__RJaUf","loading-step":"climbing_stairs_loading-step__ajd8b"};